import { render, staticRenderFns } from "./AhpImprovementsToggle.vue?vue&type=template&id=72383a38&"
import script from "./AhpImprovementsToggle.vue?vue&type=script&lang=js&"
export * from "./AhpImprovementsToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports